'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _themes = require('../../themes'),
    _propTypes3 = require('../../propTypes'),
    _componentTheme = require('./componentTheme'),
    _componentTheme2 = _interopRequireDefault(_componentTheme),
    _icons = require('../../icons'),
    _Button = require('../../Button'),
    _Button2 = _interopRequireDefault(_Button),
    _ListHeader = require('../ListHeader'),
    _ListHeader2 = _interopRequireDefault(_ListHeader);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Styled = {
  hr: {},
  li: {}
};
Styled.ul = _styledComponents2.default.ul.withConfig({
  displayName: 'List__ul'
})(['max-height:60vh;margin:0;padding:0;overflow-y:auto;background-color:', ';& > li:first-child > h3{border-top:none;}'], (0, _themes.getStyle)('List_backgroundColor')), Styled.li.base = _styledComponents2.default.li.withConfig({
  displayName: 'List__base'
})(['display:block;color:', ';font-family:', ';font-size:', ';font-weight:', ';& > ul{display:none;}'], (0, _themes.getStyle)('ListItem_color'), (0, _themes.getStyle)('ListItem_fontFamily'), function (props) {
  return props.theme.vstui.rem((0, _themes.getStyle)('ListItem_fontSize')(props));
}, (0, _themes.getStyle)('ListItem_fontWeight')), Styled.li.start = (0, _styledComponents2.default)(Styled.li.base).withConfig({
  displayName: 'List__start'
})(['padding-top:4px;']), Styled.li.end = (0, _styledComponents2.default)(Styled.li.base).withConfig({
  displayName: 'List__end'
})(['padding-bottom:4px;']), Styled.li.startEnd = (0, _styledComponents2.default)(Styled.li.base).withConfig({
  displayName: 'List__startEnd'
})(['padding-top:4px;padding-bottom:4px;']), Styled.hr.divider = _styledComponents2.default.hr.withConfig({
  displayName: 'List__divider'
})(['margin:0;border-style:none none solid;border-width:1px;border-color:', ';'], (0, _themes.getStyle)('ListDivider_color'));

var ListItemButton = function (_Component) {
  function ListItemButton() {
    return _classCallCheck(this, ListItemButton), _possibleConstructorReturn(this, (ListItemButton.__proto__ || Object.getPrototypeOf(ListItemButton)).apply(this, arguments));
  }

  return _inherits(ListItemButton, _Component), _createClass(ListItemButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Button2.default, _extends({}, this.props, {
        fullWidth: !0,
        naked: !0
      }));
    }
  }]), ListItemButton;
}(_react.Component),
    List = function (_Component2) {
  function List() {
    return _classCallCheck(this, List), _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
  }

  return _inherits(List, _Component2), _createClass(List, [{
    key: 'getThemedListItemButton',
    value: function getThemedListItemButton(theme) {
      return (0, _themes.createThemedComponent)(ListItemButton, {
        Button_backgroundColor_themePrimaryNaked_active: (0, _themes.getStyle)('ListItem_backgroundColor_hover')({
          theme: theme
        }),
        Button_backgroundColor_themePrimaryNaked_focus: (0, _themes.getStyle)('ListItem_backgroundColor_hover')({
          theme: theme
        }),
        Button_backgroundColor_themePrimaryNaked_hover: (0, _themes.getStyle)('ListItem_backgroundColor_hover')({
          theme: theme
        }),
        Button_color_themePrimaryNaked: (0, _themes.getStyle)('ListItem_color')({
          theme: theme
        }),
        Button_color_themePrimaryNaked_active: (0, _themes.getStyle)('ListItem_color')({
          theme: theme
        }),
        Button_color_themePrimaryNaked_focus: (0, _themes.getStyle)('ListItem_color')({
          theme: theme
        }),
        Button_color_themePrimaryNaked_hover: (0, _themes.getStyle)('ListItem_color')({
          theme: theme
        }),
        Button_fontFamily: (0, _themes.getStyle)('ListItem_fontFamily')({
          theme: theme
        }),
        Button_fontSize_medium: (0, _themes.getStyle)('ListItem_fontSize')({
          theme: theme
        }),
        Button_fontWeight_naked: (0, _themes.getStyle)('ListItem_fontWeight')({
          theme: theme
        }),
        Button_paddingHorizontal_fullWidth: (0, _themes.getStyle)('ListItem_paddingHorizontal')({
          theme: theme
        }),
        Button_borderRadius: 0,
        Button_boxShadow_themePrimaryNaked_focus: (0, _themes.getStyle)('ListItem_boxShadow_focus')({
          theme: theme
        }),
        ButtonContent_justifyContent: 'left'
      });
    }
  }, {
    key: 'getContent',
    value: function getContent(_ref) {
      var data = _ref.data,
          theme = _ref.theme,
          ThemedListItemButton = _ref.ThemedListItemButton,
          content = [];
      return data.forEach(function (listGroup, groupIndex) {
        var header = listGroup.header,
            listItems = listGroup.listItems;
        header ? content.push(_react2.default.createElement(Styled.li.base, {
          key: header,
          theme: theme
        }, _react2.default.createElement(_ListHeader2.default, {
          theme: theme
        }, header))) : 0 !== groupIndex && content.push(_react2.default.createElement(Styled.hr.divider, {
          key: 'group' + groupIndex + '-divider',
          theme: theme
        })), listItems && listItems.forEach(function (listItem, i) {
          var text = listItem.text,
              type = listItem.type,
              onClick = listItem.onClick,
              href = listItem.href,
              target = listItem.target,
              ListItemComponent = void 0;
          ListItemComponent = 1 === listItems.length ? Styled.li.startEnd : 0 === i ? Styled.li.start : i === listItems.length - 1 ? Styled.li.end : Styled.li.base, content.push(_react2.default.createElement(ListItemComponent, {
            key: header + '-' + text,
            theme: theme
          }, _react2.default.createElement(ThemedListItemButton, {
            "aria-pressed": 'false',
            href: href,
            iconStart: 'radioGroup' === type && _react2.default.createElement(_icons.Checkmark, null),
            onClick: onClick,
            target: target
          }, text)));
        });
      }), _react2.default.createElement(Styled.ul, {
        theme: theme
      }, content);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          themeProp = _props.theme,
          theme = (0, _componentTheme2.default)(themeProp),
          ThemedListItemButton = this.getThemedListItemButton(theme),
          content = this.getContent({
        data: data,
        theme: theme,
        ThemedListItemButton: ThemedListItemButton
      });
      return content;
    }
  }]), List;
}(_react.Component);

List.propTypes = {
  data: _propTypes2.default.array,
  theme: _propTypes3.themeShape
}, List.defaultProps = {
  theme: (0, _themes.createTheme)()
}, List.displayName = 'List';
var ListWithTheme = (0, _themes.withTheme)(List);
ListWithTheme.WrappedComponent = List, exports.default = ListWithTheme;